<template>
  <div class="service-wrap mb-4">
    <div class="slider-wrap">
      <div class="owl-carousel service-carousel nav-center mb-3" id="large-img">
        <Carousel
          class="slider detail-bigimg"
          id="gallery"
          :items-to-show="1"
          :wrap-around="false"
          v-model="currentSlide"
        >
          <Slide v-for="(image, index) in images" :key="index" class="service-img">
            <img
              :src="require(`@/assets/img/services/${image.src}`)"
              :alt="image.alt"
              class="img-fluid"
            />
          </Slide>
          <template #addons>
            <Navigation />
          </template>
        </Carousel>
      </div>
      <a
        href="#"
        @click.prevent="openLightboxGallery"
        class="btn btn-white btn-sm view-btn"
      >
        <i class="feather-image me-1"></i>View all 20 Images
      </a>
    </div>

    <div class="owl-carousel slider-nav-thumbnails nav-center" id="small-img">
      <Carousel
        id="thumbnails"
        :items-to-show="5"
        :wrap-around="true"
        v-model="currentSlide"
        ref="carousel"
      >
        <Slide v-for="(image, index) in imagesOne" :key="index">
          <div @click="slideTo(index)">
            <img
              :src="require(`@/assets/img/services/${image.src}`)"
              :alt="image.alt"
              class="img-fluid"
            />
          </div>
        </Slide>
      </Carousel>
    </div>
  </div>
  <vue-easy-lightbox
    :visible="visible"
    :index="index"
    :imgs="
      images.map((image) => ({
        src: require(`@/assets/img/services/${image.src}`),
      }))
    "
    @hide="visible = false"
    @on-prev="handlePrev"
    @on-next="handleNext"
  />
</template>

<script>
import VueEasyLightbox from "vue-easy-lightbox";
import { defineComponent } from "vue";
import { Carousel, Slide, Navigation } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";

export default defineComponent({
  components: {
    Carousel,
    Slide,
    Navigation,
    VueEasyLightbox,
  },
  data() {
    return {
      visible: false,
      index: 0,
      currentSlide: 0,
      images: [
        { src: "service-slider-01.jpg", alt: "Slider Img 1" },
        { src: "service-slider-02.jpg", alt: "Slider Img 2" },
        { src: "service-slider-03.jpg", alt: "Slider Img 3" },
        { src: "service-slider-04.jpg", alt: "Slider Img 4" },
        { src: "service-slider-05.jpg", alt: "Slider Img 5" },
        { src: "service-slider-06.jpg", alt: "Slider Img 6" },
      ],
      imagesOne: [
        { src: "service-thumb-01.jpg", alt: "Thumbnail Img 1" },
        { src: "service-thumb-02.jpg", alt: "Thumbnail Img 2" },
        { src: "service-thumb-03.jpg", alt: "Thumbnail Img 3" },
        { src: "service-thumb-04.jpg", alt: "Thumbnail Img 4" },
        { src: "service-thumb-05.jpg", alt: "Thumbnail Img 5" },
        { src: "service-thumb-06.jpg", alt: "Thumbnail Img 6" },
      ],
    };
  },
  methods: {
    openLightbox(index) {
      this.index = index; // Set current index
      this.visible = true; // Show lightbox
    },
    openLightboxGallery() {
      this.index = 0; // Start from the first image
      this.visible = true; // Show lightbox
    },
    handlePrev() {
      // Handle previous image logic (if needed)
    },
    handleNext() {
      // Handle next image logic (if needed)
    },
    slideTo(index) {
      this.currentSlide = index; // Change main slider to the thumbnail clicked
    },
  },
});
</script>
